import { createApiClientModal as e } from "@scalar/api-client/layouts/Modal";
import { ref as r } from "vue";
const n = r(null), a = () => ({
  client: n,
  init: async (i) => {
    const t = await e(i);
    return n.value = t, t;
  }
});
export {
  a as useApiClient
};
